import React from "react";
import { IconX } from "../common/WireframeIcons";
import { PlanLimitDetails } from "../../types/billing";
import { getPlanLimitLabel } from "../../utils/billing";

interface PlanLimitModalProps {
  open: boolean;
  details: PlanLimitDetails | null;
  onClose: () => void;
  onUpgradeMonthly: () => Promise<void> | void;
  onUpgradeYearly: () => Promise<void> | void;
  loading?: boolean;
}

export function PlanLimitModal({
  open,
  details,
  onClose,
  onUpgradeMonthly,
  onUpgradeYearly,
  loading = false,
}: PlanLimitModalProps) {
  if (!open || !details) return null;

  return (
    <div className="settings-drawer-container settings-drawer-container--modal" role="dialog" aria-modal="true" aria-labelledby="plan-limit-title">
      <button type="button" className="settings-drawer-backdrop" onClick={onClose} aria-label="Cerrar modal" />
      <div className="settings-drawer settings-drawer--modal billing-limit-modal">
        <button type="button" className="settings-drawer-close" onClick={onClose} aria-label="Cerrar">
          <IconX className="w-5 h-5" />
        </button>
        <p className="settings-drawer-label">Límite del plan</p>
        <h3 id="plan-limit-title" className="settings-drawer-title">Has alcanzado el límite del plan Free</h3>
        <p className="settings-drawer-subtitle">
          {getPlanLimitLabel(details.metric)}: {details.current} / {details.limit}
        </p>
        <div className="panel" style={{ background: "#f8fafc", borderColor: "#dbe4f0" }}>
          <p style={{ margin: 0, color: "#2c3e50", fontSize: "0.9rem" }}>
            Actualiza a Pro para seguir creando elementos y procesando más movimientos sin bloqueos.
          </p>
        </div>
        <div className="settings-drawer-actions">
          <button type="button" className="btn btn-primary" onClick={onUpgradeMonthly} disabled={loading}>
            {loading ? "Abriendo checkout..." : "Pasar a Pro mensual (2,99€)"}
          </button>
          <button type="button" className="btn btn-secondary" onClick={onUpgradeYearly} disabled={loading}>
            {loading ? "Abriendo checkout..." : "Pasar a Pro anual (29€)"}
          </button>
          <button type="button" className="btn btn-light" onClick={onClose} disabled={loading}>
            Más tarde
          </button>
        </div>
      </div>
    </div>
  );
}
